import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { 
    getNotificationConfigForUserService, 
    getUserDeliveryService, 
    getUserDocumentService, 
    getUserTransactionService,
    exportUserDeliveryService,
    exportUserTransactionService
} from '../../../services/userServices';

import { ListAccount } from './types';
import { AccountArgs } from 'MyAccountPlus-UIComponents';

const initialState: ListAccount = {
    loading: false,
    error: "",
    accountDocuments: {
        content: [],
        empty: false,
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
        pageRequest: {
            offset: 0,
            pageNumber: 0,
            pageSize: 0,
            paged: 0
        },
        pageNumber: 0
    },
    accountTransactions: {
        empty: false,
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
        pageRequest: {
            offset: 0,
            pageNumber: 0,
            pageSize: 0,
            paged: 0
        },
        pageNumber: 0,
        content: []
    },
    accountDeliveries: {
        empty: false,
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
        pageRequest: {
            offset: 0,
            pageNumber: 0,
            pageSize: 0,
            paged: 0
        },
        pageNumber: 0,
        content: []
    },
    notificationConfigForUser: []
}

export const getUserDocumentsThunk = createAsyncThunk("listAccountSlice/getlistAccountThunk", async (args: AccountArgs) => {
    try {
        const { data } = await getUserDocumentService(args)
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getUserTransactionsThunk = createAsyncThunk("listAccountSlice/getUserTransactionsThunk", async (args: AccountArgs) => {
    try {
        const { data } = await getUserTransactionService(args)
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getUserDeliveriesThunk = createAsyncThunk("listAccountSlice/getUserDeliveriesThunk", async (args: AccountArgs) => {
    try {
        const { data } = await getUserDeliveryService(args)
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getNotificationConfigForUserThunk = createAsyncThunk("listAccountSlice/getNotificationConfigForUserThunk", async () => {
    try {
        const { data } = await getNotificationConfigForUserService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const exportUserDeliveriesThunk = createAsyncThunk("listAccountSlice/exportUserDeliveriesThunk", async (args: { account_id: string, format: 'csv' | 'excel' }) => {
    try {
        const { data } = await exportUserDeliveryService({ account_id: args.account_id, format: args.format })
        return { success: true }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const exportUserTransactionsThunk = createAsyncThunk("listAccountSlice/exportUserTransactionsThunk", async (args: { account_id: string, format: 'csv' | 'excel' }) => {
    try {
        const { data } = await exportUserTransactionService({ account_id: args.account_id, format: args.format})
        return { success: true }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const listAccountSlice = createSlice({
    name: 'listAccountSlice',
    initialState,
    reducers: {
        errorReducer: (state) => {
            state.error = ""
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getUserDocumentsThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getUserDocumentsThunk.fulfilled, (state, action) => {
                state.accountDocuments = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getUserDocumentsThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getUserDeliveriesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getUserDeliveriesThunk.fulfilled, (state, action) => {
                state.accountDeliveries = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getUserDeliveriesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getUserTransactionsThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getUserTransactionsThunk.fulfilled, (state, action) => {
                state.accountTransactions = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getUserTransactionsThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getNotificationConfigForUserThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getNotificationConfigForUserThunk.fulfilled, (state, action) => {
                state.notificationConfigForUser = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getNotificationConfigForUserThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
    },
})

export const listAccountActions = listAccountSlice.actions
export default listAccountSlice.reducer;